var _EmptyValue, _Divider, _EmptyValue2, _p;
import React, { Fragment, cloneElement } from 'react';
import { Highlighter, Radio, Divider, Checkbox } from '@ovpn-ui/core';
import maybeDataTestId from '../../../utils/maybeDataTestId';
import { EmptyValue, Option, OptionsList, GroupTitle } from './DropdownOptions.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TEST_ID = 'ovpn-dropdown';
export default function DropdownOptions({
  options,
  groups,
  multiple,
  selectAll,
  selectAllLabel = 'Select All',
  withSearchHighlight,
  icon,
  checkedIcon,
  variant,
  multipleSelectedValues,
  searchValue,
  isSelected,
  handleSelectAll,
  handleClickItem,
  renderOption: RenderOption
}) {
  const renderHr = index => {
    // renders hr element each 3 rows
    if (variant === 'button' && (index + 2) % 3 === 1) {
      return /*#__PURE__*/_jsx(Divider, {}, index);
    }
    return null;
  };
  const renderCheckedIcon = option => {
    const isChecked = option ? isSelected(option) : multipleSelectedValues.length === options.length;
    if (checkedIcon && !multiple) {
      return /*#__PURE__*/_jsx(Radio, {
        size: "sm",
        checked: isChecked,
        readOnly: true,
        disabled: Boolean(option == null ? void 0 : option.disabled)
      });
    }
    if (checkedIcon && multiple) {
      return /*#__PURE__*/_jsx(Checkbox, {
        size: "sm",
        checked: isChecked,
        readOnly: true,
        disabled: Boolean(option == null ? void 0 : option.disabled)
      });
    }
    return null;
  };
  if (groups) {
    const groupsMap = groups.reduce((map, group) => {
      // eslint-disable-next-line no-param-reassign
      map[group.id] = group.title;
      return map;
    }, {});
    const groupedOptions = options.reduce((target, option) => {
      var _ref;
      // eslint-disable-next-line no-param-reassign
      (target[_ref = option.group] || (target[_ref] = [])).push(option);
      return target;
    }, {});
    return /*#__PURE__*/_jsxs(OptionsList, {
      role: "list",
      children: [!options.length && (_EmptyValue || (_EmptyValue = /*#__PURE__*/_jsx(EmptyValue, {
        children: "No Options"
      }))), multiple && selectAll && options.length > 0 && /*#__PURE__*/_jsxs(Option, {
        role: "listitem",
        isSelected: false,
        onClick: handleSelectAll,
        children: [/*#__PURE__*/_jsxs("span", {
          children: [icon && /*#__PURE__*/cloneElement(icon, {
            className: 'ovpn-dropdown-icon'
          }), /*#__PURE__*/_jsx("p", {
            children: selectAllLabel
          })]
        }), renderCheckedIcon()]
      }), Object.keys(groupedOptions).map((group, groupIndex) => /*#__PURE__*/_jsxs(Fragment, {
        children: [(groupIndex > 0 || multiple && selectAll && options.length > 0) && (_Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {}))), /*#__PURE__*/_jsx(GroupTitle, {
          children: groupsMap[group]
        }), groupedOptions[group].map((option, optionIndex) => {
          const selected = isSelected(option);
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsxs(Option, {
              role: "listitem",
              ...maybeDataTestId(TEST_ID, `option${optionIndex}`),
              isSelected: selected,
              "data-disabled": Boolean(option.disabled) || undefined,
              onClick: () => handleClickItem(option),
              children: [/*#__PURE__*/_jsxs("span", {
                role: "presentation",
                children: [icon && /*#__PURE__*/cloneElement(icon, {
                  className: 'ovpn-dropdown-icon'
                }), !RenderOption && (withSearchHighlight && searchValue ? /*#__PURE__*/_jsx(Highlighter, {
                  highlight: searchValue,
                  children: option.title
                }) : option.title), RenderOption && /*#__PURE__*/_jsx(RenderOption, {
                  option: option,
                  selected: selected,
                  search: searchValue
                })]
              }), renderCheckedIcon(option)]
            }), renderHr(optionIndex)]
          }, `${option.title}${option.id}`);
        })]
      }, group))]
    });
  }
  return /*#__PURE__*/_jsxs(OptionsList, {
    role: "list",
    children: [!options.length && (_EmptyValue2 || (_EmptyValue2 = /*#__PURE__*/_jsx(EmptyValue, {
      children: "No Options"
    }))), multiple && selectAll && options.length > 0 && /*#__PURE__*/_jsxs(Option, {
      role: "listitem",
      isSelected: false,
      onClick: handleSelectAll,
      children: [/*#__PURE__*/_jsxs("span", {
        children: [icon && /*#__PURE__*/cloneElement(icon, {
          className: 'ovpn-dropdown-icon'
        }), _p || (_p = /*#__PURE__*/_jsx("p", {
          children: "Select All"
        }))]
      }), renderCheckedIcon()]
    }), options.map((option, index) => {
      const selected = isSelected(option);
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsxs(Option, {
          role: "listitem",
          ...maybeDataTestId(TEST_ID, `option${index}`),
          isSelected: selected,
          "data-disabled": Boolean(option.disabled) || undefined,
          onClick: () => handleClickItem(option),
          children: [/*#__PURE__*/_jsxs("span", {
            role: "presentation",
            children: [icon && /*#__PURE__*/cloneElement(icon, {
              className: 'ovpn-dropdown-icon'
            }), !RenderOption && (withSearchHighlight && searchValue ? /*#__PURE__*/_jsx(Highlighter, {
              highlight: searchValue,
              children: option.title
            }) : option.title), RenderOption && /*#__PURE__*/_jsx(RenderOption, {
              option: option,
              selected: selected,
              search: searchValue
            })]
          }), renderCheckedIcon(option)]
        }), renderHr(index)]
      }, `${option.title}${option.id}`);
    })]
  });
}